import { combineReducers } from 'redux';
import auth from './auth/auth.slice';
import importPro from './importProduct/importProduct.slice';

export default combineReducers({
  auth,
  importPro,
});
